// // // components/publicWebsite/ui/ProgressHistory/ProgressHistory.tsx
// // import React from "react";
// // import styles from "@/assets/css/applicationTracker.module.css";

// // interface ProgressUpdate {
// //   id: string;
// //   title: string;
// //   date: string;
// //   isLast?: boolean;
// // }

// // interface ProgressHistoryProps {
// //   currentStatus: string;
// // }

// // const ProgressHistory: React.FC<ProgressHistoryProps> = ({ currentStatus }) => {
// //   // Static updates - aap isko API se bhi fetch kar sakte hain
// //   const getProgressUpdates = (): ProgressUpdate[] => {
// //     const baseUpdates: ProgressUpdate[] = [
// //       {
// //         id: "submitted",
// //         title: "Application Submitted",
// //         date: new Date().toLocaleDateString('en-US', { 
// //           month: 'long', 
// //           day: 'numeric', 
// //           year: 'numeric' 
// //         })
// //       },
// //       {
// //         id: "reviewed",
// //         title: "Application Reviewed", 
// //         date: new Date(Date.now() + 5 * 24 * 60 * 60 * 1000).toLocaleDateString('en-US', { 
// //           month: 'long', 
// //           day: 'numeric', 
// //           year: 'numeric' 
// //         })
// //       }
// //     ];

// //     // Current status ke according additional updates add karenge
// //     if (currentStatus === "visitScheduled" || currentStatus === "approved" || currentStatus === "enrolled") {
// //       baseUpdates.push({
// //         id: "visitScheduled",
// //         title: "Visit Scheduled",
// //         date: new Date(Date.now() + 10 * 24 * 60 * 60 * 1000).toLocaleDateString('en-US', { 
// //           month: 'long', 
// //           day: 'numeric', 
// //           year: 'numeric' 
// //         })
// //       });
// //     }

// //     if (currentStatus === "approved" || currentStatus === "enrolled") {
// //       baseUpdates.push({
// //         id: "approved",
// //         title: "Application Approved",
// //         date: new Date(Date.now() + 15 * 24 * 60 * 60 * 1000).toLocaleDateString('en-US', { 
// //           month: 'long', 
// //           day: 'numeric', 
// //           year: 'numeric' 
// //         })
// //       });
// //     }

// //     if (currentStatus === "enrolled") {
// //       baseUpdates.push({
// //         id: "enrolled",
// //         title: "Student Enrolled",
// //         date: new Date(Date.now() + 20 * 24 * 60 * 60 * 1000).toLocaleDateString('en-US', { 
// //           month: 'long', 
// //           day: 'numeric', 
// //           year: 'numeric' 
// //         }),
// //         isLast: true
// //       });
// //     }

   
// //     if (baseUpdates.length > 0) {
// //       baseUpdates[baseUpdates.length - 1].isLast = true;
// //     }

// //     return baseUpdates;
// //   };

// //   const updates = getProgressUpdates();

// //   return (
// //     <div className={styles.section}>
// //       <h3>Past Updates</h3>
// //       <ul className={styles.updates}>
// //         {updates.map((update, index) => (
// //           <li key={update.id}>
// //             <div>
// //               <div className={styles.beforeStyle}>
// //                 <span className={styles.circle}></span>
// //                 {!update.isLast && <span className={styles.line}></span>}
// //               </div>
// //               <span>{update.title}</span>
// //             </div>
// //             <span>{update.date}</span>
// //           </li>
// //         ))}
// //       </ul>
// //     </div>
// //   );
// // };

// // export default ProgressHistory;




// // components/publicWebsite/ui/ProgressHistory/ProgressHistory.tsx
// "use client";

// import React from "react";
// import styles from "@/assets/css/applicationTracker.module.css";

// type StatusCode =
//   | "SUBMITTED"
//   | "REVIEWED"
//   | "VISITSCHEDULED"
//   | "APPROVED"
//   | "ENROLLED";

// interface ApiStatus {
//   id?: string;
//   status?: { code?: StatusCode };
//   statusDate?: string; // ISO
// }

// interface ProgressUpdate {
//   id: string;
//   title: string;
//   date: string; // formatted for UI
//   isLast?: boolean;
// }

// interface ProgressHistoryProps {
//   studentStatuses?: ApiStatus[];
//   history?: ProgressUpdate[]; // optional override
// }

// function labelFor(code: StatusCode): string {
//   switch (code) {
//     case "SUBMITTED": return "Application Submitted";
//     case "REVIEWED": return "Application Reviewed";
//     case "VISITSCHEDULED": return "Visit Scheduled";
//     case "APPROVED": return "Application Approved";
//     case "ENROLLED": return "Student Enrolled";
//   }
// }

// function formatIST(iso?: string): string {
//   if (!iso) return "—";
//   const d = new Date(iso);
//   if (isNaN(d.getTime())) return "—";
//   return new Intl.DateTimeFormat("en-IN", {
//     timeZone: "Asia/Kolkata",
//     year: "numeric",
//     month: "long",
//     day: "numeric",
//   }).format(d);
// }

// function mapStatusesToUpdates(statuses: ApiStatus[] | undefined): ProgressUpdate[] {
//   if (!statuses?.length) return [];
//   const sorted = [...statuses].sort(
//     (a, b) => new Date(a.statusDate ?? 0).getTime() - new Date(b.statusDate ?? 0).getTime()
//   );

//   return sorted
//     .filter(s => s.status?.code)
//     .map((s, idx, arr) => ({
//       id: s.id ?? `${s.status!.code}-${idx}`,
//       title: labelFor(s.status!.code as StatusCode),
//       date: formatIST(s.statusDate),
//       isLast: idx === arr.length - 1,
//     }));
// }

// export default function ProgressHistory({ history, studentStatuses }: ProgressHistoryProps) {
//   const updates = (history?.length ? history : mapStatusesToUpdates(studentStatuses)) ?? [];

//   if (!updates.length) {
//     return (
//       <div className={styles.section}>
//         <h3>Past Updates</h3>
//         <p>No updates yet.</p>
//       </div>
//     );
//   }

//   return (
//     <div className={styles.section}>
//       <h3>Past Updates</h3>
//       <ul className={styles.updates}>
//         {updates.map((u) => (
//           <li key={u.id}>
//             <div>
//               <div className={styles.beforeStyle}>
//                 <span className={styles.circle}></span>
//                 {!u.isLast && <span className={styles.line}></span>}
//               </div>
//               <span>{u.title}</span>
//             </div>
//             <span>{u.date}</span>
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// }




"use client";

import React from "react";
import styles from "@/assets/css/applicationTracker.module.css";

type StatusCode =
  | "SUBMITTED"
  | "REVIEWED"
  | "VISITSCHEDULED"
  | "APPROVED"
  | "ENROLLED";

interface ApiStatus {
  id?: string;
  status?: { code?: StatusCode };
  statusDate?: string; // ISO
}

interface ProgressUpdate {
  id: string;
  title: string;
  date: string; // formatted for UI
  isLast?: boolean;
}

interface ProgressHistoryProps {
  studentStatuses?: ApiStatus[];
  history?: ProgressUpdate[]; // optional override
}

function labelFor(code: StatusCode): string {
  switch (code) {
    case "SUBMITTED": return "Application Submitted";
    case "REVIEWED": return "Application Reviewed";
    case "VISITSCHEDULED": return "Visit Scheduled";
    case "APPROVED": return "Application Approved";
    case "ENROLLED": return "Student Enrolled";
  }
}

function formatIST(iso?: string): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "—";
  return new Intl.DateTimeFormat("en-IN", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(d);
}

function mapStatusesToUpdates(statuses: ApiStatus[] | undefined): ProgressUpdate[] {
  if (!statuses?.length) return [];
  const sorted = [...statuses].sort(
    (a, b) => new Date(a.statusDate ?? 0).getTime() - new Date(b.statusDate ?? 0).getTime()
  );

  return sorted
    .filter(s => s.status?.code)
    .map((s, idx, arr) => ({
      id: s.id ?? `${s.status!.code}-${idx}`,
      title: labelFor(s.status!.code as StatusCode),
      date: formatIST(s.statusDate),
      isLast: idx === arr.length - 1,
    }));
}

export default function ProgressHistory({ history, studentStatuses }: ProgressHistoryProps) {
  const updates = (history?.length ? history : mapStatusesToUpdates(studentStatuses)) ?? [];

  if (!updates.length) {
    return (
      <div className={styles.section}>
        <h3>Past Updates</h3>
        <p>No updates yet.</p>
      </div>
    );
  }

  return (
    <div className={styles.section}>
      <h3>Past Updates</h3>
      <ul className={styles.updates}>
        {updates.map((u) => (
          <li key={u.id}>
            <div>
              <div className={styles.beforeStyle}>
                <span className={styles.circle}></span>
                {!u.isLast && <span className={styles.line}></span>}
              </div>
              <span>{u.title}</span>
            </div>
            <span>{u.date}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
